import { Country } from "./Country";

const RESTRICTED_HTS_PER_COUNTRY = {
  [Country.MX]: ["7102.39", "7113.19", "7103.91", "7113.11"],
  [Country.CH]: ["7116.20", "7117.19", "7113.11", "7113.19"],
};

export default RESTRICTED_HTS_PER_COUNTRY;
